import styled from 'styled-components';
import FreeCancellationIconSvg from '../../stories/assets/bus/free-cancellation.svg';

const FreeCancellationIcon = styled(
  FreeCancellationIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)`
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.fill || '#647a97'};
`;

export default FreeCancellationIcon;
